/*
* Copyright (C) Regione Lombardia
*/
import { Injectable } from '@angular/core';
import { OperaStatoEnum, PermessiEnum } from '@models';
import { OperaService } from './opera.service';
import { UtenteService } from './utente.service';

@Injectable({
    providedIn: 'root'
})
export class PermessiService {

    private _PERMESSI_OPERA: { [key: string]: boolean } = {
        OPERA_EDIT: false,
        OPERA_DELETE: false,
        OPERA_WORKFLOW_NEXT: false,
        OPERA_EXPORT_SINTESI_OPERA: false,
        OPERA_CHANGE_ALL_STATO: false,
    };
    private _PERMESSI_PROGETTO: { [key: string]: boolean } = {
        PROGETTO_CREATE: false,
    };

    get opera() { return this._PERMESSI_OPERA; }
    get progetto() { return this._PERMESSI_PROGETTO; }

    constructor(
        private utenteService: UtenteService,
        private operaService: OperaService,
    ) { }

    /* OPERA: Permessi */
    public initPermessiOpera() {
        Object.entries(this._PERMESSI_OPERA).forEach(([key, value]) =>
            this._PERMESSI_OPERA[key] = this._checkPermessiOpera(key)
        );
    }
    private _checkPermessiOpera(permesso: string): boolean {
        if (permesso === PermessiEnum.OPERA_EDIT.toString()) {
            return this.can_opera_OPERA_EDIT();
        }
        if (permesso === PermessiEnum.OPERA_DELETE.toString()) {
            return this.can_opera_OPERA_DELETE();
        }
        if (permesso === PermessiEnum.OPERA_CHANGE_ALL_STATO.toString()) {
            return this.can_opera_OPERA_CHANGE_ALL_STATO();
        }
        if (permesso === PermessiEnum.OPERA_WORKFLOW_NEXT.toString()) {
            return this.can_opera_OPERA_WORKFLOW_NEXT();
        }
        if (permesso === PermessiEnum.OPERA_EXPORT_SINTESI_OPERA.toString()) {
            return this.can_opera_OPERA_EXPORT_SINTESI_OPERA();
        }
        if (permesso === PermessiEnum.OPERA_EXPORT_ELABORAZIONE_TERRITORIO.toString()) {
            return this.can_opera_OPERA_EXPORT_ELABORAZIONE_TERRITORIO();
        }
        if (permesso === PermessiEnum.OPERA_EXPORT_CONFRONTO_SOGGETTI_TERRITORIALI.toString()) {
            return this.can_opera_OPERA_EXPORT_CONFRONTO_SOGGETTI_TERRITORIALI();
        }
        return false;
    }
    private can_opera_OPERA_EDIT(): boolean {
        if (OperaStatoEnum.BOZZA === this.operaService.operaSession?.idStato || OperaStatoEnum.COMPLETATA === this.operaService.operaSession?.idStato) {
            return this.utenteService.isRuoloAmministratore() || this._operatoreOpera();
        } else if (OperaStatoEnum.VERIFICATA === this.operaService.operaSession?.idStato) {
            return this.utenteService.isRuoloAmministratore();
        }
        return false;
    }
    private can_opera_OPERA_DELETE(): boolean {
        switch(this.operaService.operaSession?.idStato) {
            case OperaStatoEnum.BOZZA:
                return this.utenteService.isRuoloAmministratore() || this._operatoreOpera();
            case OperaStatoEnum.COMPLETATA:
                return this.utenteService.isRuoloAmministratore();
        }
        return false;
    }
    private can_opera_OPERA_WORKFLOW_NEXT(): boolean {
        switch(this.operaService.operaSession?.idStato) {
            case OperaStatoEnum.BOZZA:
                return this._operatoreOpera() || this.utenteService.isRuoloAmministratore();
            case OperaStatoEnum.COMPLETATA:
                return this.utenteService.isRuoloAmministratore();
            // case OperaStatoEnum.VERIFICATA:
            //     return this.utenteService.isRuoloAmministratore();
        }
        return false;
    }
    private can_opera_OPERA_CHANGE_ALL_STATO(): boolean {
        return this.utenteService.isRuoloAmministratore();
    }
    private can_opera_OPERA_EXPORT_SINTESI_OPERA() {
        return this.operaService.operaSession?.idStato === OperaStatoEnum.VERIFICATA;
    }
    private can_opera_OPERA_EXPORT_ELABORAZIONE_TERRITORIO() {
        return this.operaService.operaSession?.idStato === OperaStatoEnum.VERIFICATA;
    }
    private can_opera_OPERA_EXPORT_CONFRONTO_SOGGETTI_TERRITORIALI() {
        return this.operaService.operaSession?.idStato === OperaStatoEnum.VERIFICATA;
    }
    private _operatoreOpera(): boolean {
        return this.utenteService.isRuoloOperatore() ||
            this.operaService.operaSession?.createdBy === this.utenteService.utente.id;
    }

    /* PROGETTO: Permessi */
    public initPermessiProgetto() {
        Object.entries(this._PERMESSI_PROGETTO).forEach(([key, value]) =>
            this._PERMESSI_PROGETTO[key] = this._checkPermessiProgetto(key)
        );
    }
    private _checkPermessiProgetto(permesso: string): boolean {
        if (permesso === PermessiEnum.PROGETTO_CREATE.toString()) {
            return this.can_opera_PROGETTO_CREATE();
        }
        return false;
    }
    private can_opera_PROGETTO_CREATE(): boolean {
        return false;
    }

}
